import moment from 'moment';

export function easternTimestampToMonthDateYear(timestamp: string) {
	return moment(timestamp).format('MM/DD/YYYY');
}
